import { useEffect, useState } from 'react'

export default function useCountdown(countdownUntil: number) {
  const [duration, setDuration] = useState<{
    minutes: number
    seconds: number
  }>({ minutes: 0, seconds: 0 })

  useEffect(() => {
    const updateDuration = () => {
      const millisecondsLeft = countdownUntil - Date.now()

      if (millisecondsLeft <= 0) {
        setDuration({ minutes: 0, seconds: 0 })
      } else {
        const minutesLeft = Math.floor(
          (millisecondsLeft % (1000 * 60 * 60)) / (1000 * 60),
        )

        const secondsLeft = Math.floor((millisecondsLeft % (1000 * 60)) / 1000)

        setDuration({ minutes: minutesLeft, seconds: secondsLeft })
      }
    }

    updateDuration()

    const interval = setInterval(updateDuration, 1000)

    return () => clearInterval(interval)
  }, [countdownUntil])

  return duration
}
